import {deserialize, deserializeAs} from 'libs/cerialize';

export class StepDto {
	@deserialize
	EntityId: number;

	@deserialize
	EntityName: string;

	@deserialize
	RecordId: number;
}